import { explainDocumentError } from "./documentErrors";
import { parseBlockContent, type BlockType, type SiteBlockInsert, type SiteBlockRow, type SiteBlockUpdate } from "../../lib/blockContentSchemas";
import type { Json } from "../../lib/database.types";
import { blockRepository } from "./blockRepository";

type Block = SiteBlockRow;
type BlockInsert = SiteBlockInsert;
type BlockUpdate = SiteBlockUpdate;

const validateContent = <T extends BlockType>(blockType: T, content: unknown) =>
  parseBlockContent(blockType, content) as Json;

export const blockService = {
  async saveDocument(pageId:string,previous:Block[],next:Block[]) {
    try{return await blockRepository.saveDocument(pageId,previous,next.map(b=>({...b,content:validateContent(b.block_type,b.content)})));}catch(error){explainDocumentError(error);}
  },
  async saveDocuments(documents:{page_id:string;previous:Block[];blocks:Block[]}[]) {
    try{return await blockRepository.saveDocuments(documents.map(d=>({...d,blocks:d.blocks.map(b=>({...b,content:validateContent(b.block_type,b.content)}))})));}catch(error){explainDocumentError(error);}
  },
  firstPicture: (pageId: string) => blockRepository.firstPicture(pageId),
  list: (pageId: string) => blockRepository.list(pageId),
  listForVersion: (siteVersionId: string) => blockRepository.listForVersion(siteVersionId),
  create: (values: BlockInsert) =>
    blockRepository.create({ ...values, content: validateContent(values.block_type, values.content ?? {}) }),
  update: (blockId: string, blockType: BlockType, values: BlockUpdate) =>
    blockRepository.update(blockId, {
      ...values,
      block_type: blockType,
      content: values.content === undefined ? undefined : validateContent(blockType, values.content),
    }),
  remove: (blockId: string) => blockRepository.remove(blockId),
  reorder: (pageId: string, parentSourceBlockId: string | null, orderedSourceBlockIds: string[]) =>
    blockRepository.reorder(pageId, parentSourceBlockId, orderedSourceBlockIds),
};
